import { FormControlLabel, Icon, Radio, RadioGroup as MuiRadioGroup } from '@mui/material';

export default function RadioGroup(props) {
    const rowDisplay = props.column ? false : true;

    return (
        <MuiRadioGroup
            {...props}
            row={rowDisplay}
            value={props.value ?? ''}
            name={props.name}
            sx={{ span: { color: 'common.black' } }}
            aria-labelledby={`${props.name}-radio-group`}
            onChange={event => props.onChange(props.name, event.target.value)}
        >
            {props.options.map((option, index) => (
                <FormControlLabel
                    key={index}
                    sx={{ mb: 0 }}
                    disabled={option.disabled}
                    value={option.value ?? ''}
                    control={
                        <Radio
                            icon={<Icon>radio_button_unchecked</Icon>}
                            checkedIcon={
                                <Icon
                                    sx={theme => ({
                                        color: `${theme.palette.success.main} !important`
                                    })}
                                >
                                    radio_button_checked
                                </Icon>
                            }
                        />
                    }
                    label={option.label}
                />
            ))}
        </MuiRadioGroup>
    );
}
